<template>
    <div class="main">
        <div class="home apply shadow">
            <div class="innerForm">
                <p class="tipText">提示：请您如实填写下列各项信息，带*为必填项，我们会严格保护您的信息安全。</p>
                <el-form label-width="80px" :model="form" ref="ruleForm" :rules="dynamicRules"
                         :validate-on-rule-change="false">
                    <div>
                        <el-row class="rowButton">
                            <span class="applicationText">申请人类别</span>
                            <el-col :span="18" class="colLeft">
                                <el-radio-group v-model="form.applicantType">
                                    <el-radio label="1" @change="changeActive(0)"
                                              :disabled="edit" ref="gongmin">公民
                                    </el-radio>
                                    <el-radio label="2" @change="changeActive(1)"
                                              :disabled="edit" ref="faren">法人/其他组织
                                    </el-radio>
                                </el-radio-group>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="box">
                        <div v-if="isActive === 0">
                            <el-row class="rowButton">
                                <span class="applicationText">公民</span>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item prop="name" label-width="150px" label="姓名">
                                        <el-input type="text" v-model="form.name" maxlength="50" :disabled="edit"/>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item prop="tel" label-width="150px" label="联系电话">
                                        <el-input type="text" v-model="form.tel" maxlength="20" :disabled="edit"/>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item prop="certificateType" label-width="150px" label="证件名称">
                                        <el-select v-model="form.certificateType" placeholder="请选择" style="width: 100%"
                                                   :disabled="edit">
                                            <el-option
                                                    v-for="item in options"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item prop="certificateNo" label-width="150px" label="证件号码">
                                        <el-input type="text" v-model="form.certificateNo" maxlength="18"
                                                  :disabled="edit"/>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item label-width="150px" label="电子邮箱" prop="email">
                                        <el-input type="text" v-model="form.email" maxlength="30" :disabled="edit"/>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item prop="postalcode" label-width="150px" label="邮政编码">
                                        <el-input type="text" v-model="form.postalcode" maxlength="100"
                                                  :disabled="edit"/>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="24">
                                    <el-form-item prop="address" label-width="150px" label="通信地址">
                                        <el-input type="text" v-model="form.address" maxlength="200" :disabled="edit"/>
                                    </el-form-item>
                                </el-col>

                            </el-row>
                        </div>
                        <div v-else-if="isActive === 1">
                            <el-row class="rowButton">
                                <span class="applicationText">法人/其他组织</span>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item prop="name" label-width="150px" label="单位名称">
                                        <el-input type="text" v-model="form.name" maxlength="150" :disabled="edit"/>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item prop="legal" label-width="150px" label="法定代表人">
                                        <el-input type="text" v-model="form.legal" maxlength="150" :disabled="edit"/>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item prop="organizationType" label-width="150px" label="组织类型">
                                        <el-select v-model="form.organizationType" placeholder="请选择" style="width: 100%"
                                                   :disabled="edit">
                                            <el-option
                                                    v-for="item in organizationType"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item prop="certificateNo" label-width="150px" label="组织机构代码">
                                        <el-input type="text" v-model="form.certificateNo" maxlength="40"
                                                  :disabled="edit"/>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item prop="licenseInfo" label-width="150px" label="营业执照信息">
                                        <el-input type="text" v-model="form.licenseInfo" maxlength="600"
                                                  :disabled="edit"/>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item prop="contactName" label-width="150px" label="联系人姓名">
                                        <el-input type="text" v-model="form.contactName" maxlength="50"
                                                  :disabled="edit"/>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item label-width="150px" label="电子邮箱" prop="email">
                                        <el-input type="text" v-model="form.email" maxlength="30" :disabled="edit"/>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item prop="postalcode" label-width="150px" label="邮政编码">
                                        <el-input type="text" v-model="form.postalcode" maxlength="100"
                                                  :disabled="edit"/>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item prop="address" label-width="150px" label="通信地址">
                                        <el-input type="text" v-model="form.address" maxlength="200" :disabled="edit"/>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item prop="tel" label-width="150px" label="联系电话">
                                        <el-input type="text" v-model="form.tel" maxlength="20" :disabled="edit"/>
                                    </el-form-item>
                                </el-col>

                            </el-row>
                        </div>
                    </div>
                    <div style="margin-bottom: 20px">
                        <el-row class="rowButton">
                            <span class="applicationText">所需信息情况</span>
                        </el-row>
                    </div>
                    <div>
                        <el-row :gutter="20">
                            <el-col :span="24">
                                <el-form-item prop="title" label-width="150px" label="标题">
                                    <el-input type="text" maxlength="200" v-model="form.title" :disabled="edit"/>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="24">
                                <el-form-item prop="applicationPurpose" label-width="150px" label="申请目的">
                                    <el-input v-model="form.applicationPurpose" maxlength="500" type="textarea"
                                              :disabled="edit"/>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="24">
                                <el-form-item prop="content" label-width="150px" label="所需信息的内容描述">
                                    <el-input v-model="form.content" maxlength="500" minlength="20" type="textarea"
                                              :disabled="edit" show-word-limit/>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="24">
                            <el-col :span="24">
                                <el-form-item label-width="150px" label="信息获取方式">
                                    <el-radio-group v-model="form.accessWay" style="text-align: left" :disabled="edit">
                                        <el-radio label="1">网上查询</el-radio>
                                        <el-radio label="2">邮寄</el-radio>
                                        <el-radio label="3">自行领取</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                    <div>
                        <el-row class="rowButton">
                            <span class="applicationText">附件</span>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="24">
                                <el-form-item label-width="150px" label="身份证正面">
                                    <el-upload
                                            :data="fileData"
                                            name="file"
                                            style="text-align: left"
                                            class="upload-demo"
                                            :action="urlAction"
                                            :on-exceed="handleExceed"
                                            :on-remove="handleRemove"
                                            :file-list="fileList"
                                            :before-upload="beforeAvatarUpload"
                                            :on-change="handleChange"
                                            :limit="1">
                                        <el-button slot="trigger" size="small" type="primary">请选择上传图片</el-button>
                                        <div slot="tip" class="el-upload__tip" style="line-height: 16px;">
                                            请上传个人身份证有人像的一面，支持jpg、jpeg、bmp、png、gif格式图片，不超过5MB，最多上传一张图片。
                                        </div>
                                    </el-upload>
                                </el-form-item>

                                <el-form-item label-width="150px" label="身份证反面">
                                    <el-upload
                                            :data="fileData"
                                            name="file"
                                            style="text-align: left"
                                            class="upload-demo"
                                            :on-exceed="handleExceed"
                                            :on-remove="handleRemove"
                                            :action="urlAction"
                                            :file-list="fileList"
                                            :before-upload="beforeAvatarUpload1"
                                            :on-change="handleChange"
                                            :limit="1">
                                        <el-button slot="trigger" size="small" type="primary">请选择上传图片</el-button>
                                        <div slot="tip" class="el-upload__tip" style="line-height: 16px;">
                                            请上传个人身份证有国徽的一面，支持jpg、jpeg、bmp、png、gif格式图片，不超过5MB，最多上传一张图片。
                                        </div>
                                    </el-upload>
                                </el-form-item>

                                <el-form-item label-width="150px" label="相关附件">
                                    <el-upload
                                            :data="fileData"
                                            namefileData="file"
                                            style="text-align: left"
                                            class="upload-demo"
                                            :on-exceed="handleExceed1"
                                            :action="urlAction"
                                            :before-upload="beforeAvatarUpload2"
                                            :on-remove="handleRemove"
                                            :file-list="fileList"
                                            :on-change="handleChange"
                                            :limit="3">
                                        <el-button slot="trigger" size="small" type="primary">请选择上传附件</el-button>
                                        <div slot="tip" class="el-upload__tip" style="line-height: 16px;">
                                            请上传10MB以下的附件。最多上传三个附件，若上传多个文件，请先采用zip或rar进行压缩。允许上传常见的图片、音视频、压缩包及文档格式的文件。
                                        </div>
                                    </el-upload>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="footer">
                        <el-button type="primary" @click="submit('ruleForm')" :disabled="isDisable"
                                   v-bind:class="{ 'buttonShow': buttomStyle }" style="font-size: 14px">提交
                        </el-button>
                        <el-button @click="route_goFun('政府信息公开申请')" type="info"
                                   style="margin-left: 50px;font-size: 14px">取消
                        </el-button>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script>
   import router from '@/router'
    export default {
        beforeRouteEnter(to, from, next) {
            next()
            if(sessionStorage.getItem('sfsmrz')!='1'){
               router.push({path:'/'})
            }
        },
        data() {
            var checkPhone = (rule, value, callback) => {
                const phoneReg = /^1[0-9][0-9]{9}$/
                if (!value) {
                    return callback(new Error('手机号码不能为空'))
                }
                setTimeout(() => {
                    if (!Number.isInteger(+value)) {
                        callback(new Error('请输入数字值'))
                    } else {
                        if (phoneReg.test(value)) {
                            callback()
                        } else {
                            callback(new Error('手机号码格式不正确'))
                        }
                    }
                }, 100)
            };

            var isCardId = (rule, value, callback) => {
                if (!value && (this.form.certificateType == 'SFZ' || this.form.certificateType == 'HZ')) {
                    return new Error("请输入证件号码)");
                }else if (this.form.certificateType == 'HZ') {
                    const cardRegHz = /^([a-zA-z]|[0-9]){5,17}$/;
                    const cardHz = cardRegHz.test(value);
                    if ( cardHz ) {
                        callback();
                    } else {
                        callback(new Error("护照格式不正确"));
                    }
                } else {
                    const cardReg = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[0-2])(([0-2][1-9])|10|20|30|31)\d{3}(\d|X|x)$/;
                    const card = cardReg.test(value);
                    const cardRegXGAM = /^[HM][0-9]{8}$/;
                    const cardXGAM = cardRegXGAM .test(value);
                    const cardRegTW = /^[0-9]{8}$/;
                    const cardTW = cardRegTW.test(value);
                    if(this.form.certificateType == 'SFZ'){
                        if ( card || cardXGAM || cardTW ) {
                            //判断座机为12位
                            callback();
                        } else {
                            callback(new Error("身份证格式不正确"));
                        }
                    }else{
                        callback(new Error("请选择证件名称"));
                    }
                }
            };

            var isAddressCode = (rule, value, callback) => {
                if (!value) {
                    return new Error("请输入邮政编码)");
                } else {
                    const addressReg = /^[0-9]{6}$/;
                    const address = addressReg.test(value);
                    if (!address) {
                        callback(new Error("邮政编码格式不正确"));
                    } else {
                        callback();
                    }
                }
            };

            var isEmailCode = (rule, value, callback) => {
                const EmailReg = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                const Email = EmailReg.test(value);
                if (!Email && Email!='') {
                    callback(new Error("电子邮箱格式不正确"));
                } else {
                    callback();
                }
            };

            return {
                responseId: '',
                attachmentId: '',
                isDisable: false,
                urlAction: window.SITE_CONFIG['baseUrl'] + '/file/uploadFile',
                buttomStyle: false,
                edit: false,
                options: [{
                    value: 'SFZ',
                    label: '身份证'
                }, {
                    value: 'HZ',
                    label: '护照'
                }],
                organizationType: [{
                    value: 'SYQY',
                    label: '商业企业'
                }, {
                    value: 'KYJG',
                    label: '科研机构'
                }, {
                    value: 'SHGYZZ',
                    label: '社会公益组织'
                }, {
                    value: 'FLFWJG',
                    label: '法律服务机构'
                }, {
                    value: 'QT',
                    label: '其他'
                }],
                backID: '',
                dialogFormVisible: false,
                formLabelWidth: '120px',
                fileList: [],
                fileData: {
                    tableUuid: '',
                    tableName: 'one',
                    tableKey: 'photo',
                },
                form: {
                    id: '',
                    applicantType: '1',
                    delFlag: '',
                    name: '',
                    tel: '',
                    certificateType: '',
                    certificateNo: '',
                    email: '',
                    postalcode: '',
                    address: '',
                    legal: '',
                    organizationType: '',
                    licenseInfo: '',
                    contactName: '',
                    title: '',
                    applicationPurpose: '',
                    content: '',
                    accessWay: '1',
                },

                rules1: {
                    name: [
                        {required: true, message: '请输入姓名', trigger: ['blur', 'change']},
                    ],
                    tel: [
                        {required: true, message: '请输入联系电话', trigger: ['blur', 'change']},
                        {validator: checkPhone, trigger: ['blur', 'change']}
                    ],
                    certificateType: [
                        {required: true, message: '请输入证件名称', trigger:['blur', 'change']}
                    ],
                    certificateNo: [
                        {required: true, message: '请输入证件号码', trigger:['blur', 'change']},
                        {validator: isCardId, trigger:['blur', 'change']}
                    ],
                    postalcode: [
                        {required: true, message: '请输入邮政编码', trigger: ['blur', 'change']},
                        {validator: isAddressCode, trigger:['blur', 'change']}
                    ],
                    address: [
                        {required: true, message: '请输入通信地址', trigger: ['blur', 'change']}
                    ],
                    title: [
                        {required: true, message: '请输入标题', trigger: ['blur', 'change']}
                    ],
                    applicationPurpose: [
                        {message: '请输入申请目的', trigger: ['blur', 'change']}
                    ],
                    content: [
                        {required: true, message: '请输入所需信息的内容描述', trigger:['blur', 'change']},
                        {min: 20, max: 500, message: '长度在 20 到 500 个字符', trigger: 'change'}
                    ],
                    email: [
                        {type: 'email', message: '请输入正确的邮箱地址', trigger: 'change'},
                        {validator: isEmailCode, trigger: "change"}
                    ],
                },
                rules2: {
                    name: [
                        {required: true, message: '请输入单位名称', trigger: ['blur', 'change']},
                    ],
                    legal: [
                        {required: true, message: '请输入法定代表人', trigger: ['blur', 'change']},
                    ],
                    organizationType: [
                        {required: true, message: '请输入组织类型', trigger: ['blur', 'change']}
                    ],
                    certificateNo: [
                        {required: true, message: '请输入组织机构代码', trigger: ['blur', 'change']}
                    ],
                    licenseInfo: [
                        {required: true, message: '请输入营业执照信息', trigger:['blur', 'change']}
                    ],
                    postalcode: [
                        {required: true, message: '请输入邮政编码', trigger: ['blur', 'change']},
                        {validator: isAddressCode, trigger:  ['blur', 'change']}
                    ],
                    contactName: [
                        {required: true, message: '请输入联系人姓名', trigger: ['blur', 'change']}
                    ],
                    address: [
                        {required: true, message: '请输入通信地址', trigger: ['blur', 'change']}
                    ],
                    tel: [
                        {required: true, message: '请输入联系电话', trigger: ['blur', 'change']},
                        {validator: checkPhone, trigger:  ['blur', 'change']}
                    ],
                    title: [
                        {required: true, message: '请输入标题', trigger: ['blur', 'change']}
                    ],
                    applicationPurpose: [
                        {message: '请输入申请目的', trigger:['blur', 'change']}
                    ],
                    content: [
                        {required: true, message: '请输入所需信息的内容描述', trigger: ['blur', 'change']},
                        {min: 20, max: 500, message: '长度在 20 到 500 个字符', trigger: 'change'}
                    ],
                    email: [
                        {type: 'email', message: '请输入正确的邮箱地址', trigger: 'change'},
                        {validator: isEmailCode, trigger: "change"}
                    ],
                },
                paramsStore: {},
                isActive: 0
            }
        },
        computed: {
            dynamicRules() {
                return this.isActive == 0 ? this.rules1 : this.rules2;
            }
        },
        watch: {
            $route(to, from) {
                this.$router.go(0)
            }
        },
        mounted() {
            if (this.$route.query.id && this.$route.query.id != 2) {
                this.getParams()
            } else {
                this.new()
            }
            this.changeRadio()
        },
        methods: {
            getParams() {
                this.$axios({
                    url: '/application/queryById',
                    method: 'get',
                    params: {
                        id: this.$route.query.id
                    }
                }).then(({data}) => {
                    if (data.code == 200) {
                        this.form = data.result
                        this.edit = true
                        this.buttomStyle = true
                    } else {
                        alert(data.msg)
                    }
                })
            },

            new() {

            },
            //回显
            changeRadio() {
                if (this.form.applicantType == 1) {
                    this.isActive = 0
                } else {
                    this.isActive = 1
                }
            },
            // radio切换
            changeActive(num) {
                this.isActive = num
                this.form.name = ''
                this.form.tel = ''
                this.form.certificateType = ''
                this.form.certificateNo = ''
                this.form.licenseInfo = ''
                this.form.email = ''
                this.form.postalcode = ''
                this.form.address = ''
                this.form.legal = ''
                this.form.organizationType = ''
                this.form.contactName = ''
                // this.$refs["ruleForm"].clearValidate()
                this.$refs["ruleForm"].resetFields()
            },
            // 返回上一步
            route_goFun(name) {
                this.$router.push({
                    path: '/',
                    query: {
                        name: name,
                        id: 1
                    }
                })
            },
            handleChange(file, fileList) {

            },
            //删除附件
            handleRemove(response, file, fileList) {
                this.attachmentId = response.response.attachmentId
                this.$axios({
                    url: '/file/deleteFile',
                    method: 'get',
                    params: {attachmentId: this.attachmentId}
                }).then(({data}) => {
                    this.$message.success(data.msg);
                    // console.log(data)
                })
            },

            //上传前
            beforeAvatarUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 5;
                let types = ['image/jpeg', 'image/jpg', 'image/png', 'image/bmp', 'image/gif'];
                const isImage = types.includes(file.type);
                if (!isImage) {
                    this.$message.error('上传图片只能是jpg、jpeg、bmp、png、gif 格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 5MB!');
                }
                if (this.fileData.tableUuid) {
                    this.form.id = this.fileData.tableUuid
                    this.fileData.tableName = 'applicationForm'
                    this.fileData.tableKey = 'basicInformationIDCarDAttach'
                } else {
                    const uuid = require('uuid')
                    this.fileData.tableUuid = uuid.v1().replace(/-/g, '')
                    this.form.id = this.fileData.tableUuid
                    this.fileData.tableName = 'applicationForm'
                    this.fileData.tableKey = 'basicInformationIDCarDAttach'
                }
                return isImage && isLt2M;
            },

            beforeAvatarUpload1(file) {
                const isLt2M1 = file.size / 1024 / 1024 < 5;
                let types = ['image/jpeg', 'image/jpg', 'image/png', 'image/bmp', 'image/gif'];
                const isImage1 = types.includes(file.type);
                if (!isImage1) {
                    this.$message.error('上传图片只能是jpg、jpeg、bmp、png、gif 格式!');
                }
                if (!isLt2M1) {
                    this.$message.error('上传图片大小不能超过 5MB!');
                }
                if (this.fileData.tableUuid) {
                    this.form.id = this.fileData.tableUuid
                    this.fileData.tableName = 'applicationForm'
                    this.fileData.tableKey = 'basicInformationIDCarDAttach'
                } else {
                    const uuid = require('uuid')
                    this.fileData.tableUuid = uuid.v1().replace(/-/g, '')
                    this.form.id = this.fileData.tableUuid
                    this.fileData.tableName = 'applicationForm'
                    this.fileData.tableKey = 'basicInformationIDCarDAttach'
                }
                return isImage1 && isLt2M1;
            },

            beforeAvatarUpload2(file) {
                const isLt2M2 = file.size / 1024 / 1024 < 10;
                if (!isLt2M2) {
                    this.$message.error('上传附件大小不能超过 10MB!');
                }
                if (this.fileData.tableUuid) {
                    this.form.id = this.fileData.tableUuid
                    this.fileData.tableName = 'applicationForm'
                    this.fileData.tableKey = 'basicInformationAttach'
                } else {
                    const uuid = require('uuid')
                    this.fileData.tableUuid = uuid.v1().replace(/-/g, '')
                    this.form.id = this.fileData.tableUuid
                    this.fileData.tableName = 'applicationForm'
                    this.fileData.tableKey = 'basicInformationAttach'
                }
                return isLt2M2;
            },

            //超出限制
            handleExceed(files, fileList) {
                this.$message.warning(`已超出限制，最多只能上传一个附件！`);
            },
            handleExceed1(files, fileList) {
                this.$message.warning(`已超出限制，最多只能上传三个附件！`);
            },
            // 提交内容
            submit(formName) {
                var formNews = {
                    loginName:sessionStorage.getItem("loginName"),
                    loginCertNo:sessionStorage.getItem("certno"),
                    userId:sessionStorage.getItem("personUuid"),
                    certType: this.form.certificateType,
                    certNo: this.form.certificateNo,
                    applicantType: this.form.applicantType,
                }
                this.$axios({
                    url: '/application/isRealName',
                    method: 'post',
                    data: this.$axios.encrypt(formNews)
                }).then(({data}) => {
                    console.log(data)
                    if (data.isRealName == true) {
                        this.$refs[formName].validate((valid) => {
                            if (valid) {
                                this.isDisable = true
                                this.$axios({
                                    url: '/application/insertOne',
                                    method: 'post',
                                    data: this.$axios.encrypt(this.form)
                                }).then(({data}) => {
                                    if (data.code == 200) {
                                        this.$message({
                                            showClose: true,
                                            message: '保存成功!',
                                            type: 'success'
                                        });
                                        var backID = data.id
                                        this.$router.push({
                                            path: '/apply-submit',
                                            query: {
                                                // name: name,
                                                saveId: data.id,
                                            }
                                        });
                                    } else {
                                        alert(data.msg)
                                        this.isDisable = false
                                    }
                                })
                            } else {
                                return false;
                            }
                            setTimeout(() => {
                                this.isDisable = false
                            }, 10000)
                        });
                    }else {
                        this.$confirm('所填信息只能是本人、本人经办企业信息或法人所属企业信息，请仔细检查申请信息是否有误。', '提示', {
                            cancelButtonText: '确定',
                            showCancelButton:false,
                            type: 'warning'})
                    }
                })

            },

        }
    }

</script>

<style>
    .apply .box {
        margin-top: 20px;
    }

    .apply .footer {
        margin-top: 20px;
        margin-bottom: 40px;
    }
</style>
